module.exports = __webpack_public_path__ + "static/media/cases_3d_02a.814b5f4c.jpg";